<div>
    <h2 mat-dialog-title class="cut-long-text">
        @if (!data?.id) {
            Neuer Datensatz
        } @else {
            Datensatz bearbeiten
        }
    </h2>
    <mat-divider></mat-divider>

    <form [formGroup]="formGroup" class="sequence-form">
        <mat-tab-group>
            <mat-tab label="Sequenz">
                <mat-dialog-content class="grid">
            <mat-form-field class="full-width">
                <mat-label>Name</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    placeholder=""
                    formControlName="name"
                />
                <mat-error>{{
                    checkForErrors(formGroup.controls["name"])
                }}</mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Konsument</mat-label>
                <mat-select formControlName="consumers">
                    @for (consumer of consumers$ | async; track consumer.id) {
                        <mat-option [value]="consumer.id">{{
                            consumer.name
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Fach/Beruf</mat-label>
                <mat-select formControlName="subjects">
                    @for (subject of subjects$ | async; track subject.id) {
                        <mat-option [value]="subject.id">{{
                            subject.name
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <div class="full-width">
                <pixl-state-cb
                    [required]="true"
                    [initValue]="this.data?.approval || ''"
                    (onStateChange)="statusChanged($event)"
                />
            </div>

            <div
                cdkDropList
                class="full-width"
                (cdkDropListDropped)="reorderBlocks($event)"
            >
            @for (seqList of sequenceList; let blockIndex = $index; track blockIndex) {
                <div class="full-width" cdkDrag>
                    <div class="border-area full-width">
                        <div class="drag-row">
                            <div class="drag-icon-container">
                                <mat-icon>drag_indicator</mat-icon>
                            </div>
                            <div class="content-column">
                                <b>{{ getBlockName(blockIndex) }} {{ blockIndex + 1 }}</b>
                                <div class="select mt-2 full-width">
                                    <pixl-multi-combo-entity-search
                                        [label]="getlabelName()"
                                        [placeHolder]="getPlaceholder()"
                                        [observable$]="searchResultObservables[blockIndex]"
                                        [namingColumn]="'name'"
                                        [externalSearch]="true"
                                        (onStateChange)="receiveStateChange($event, blockIndex)"
                                        (onSearchChange)="receiveSearchQuery($event, blockIndex)"
                                        (scrolledToEnd)="loadMoreTasks($event, blockIndex)"
                                        [(selectedValues)]="splitSelectedTasks[blockIndex]"
                                        />
                                </div>

                                <div class="mb-1 full-width">Anordnen (Drag'n Drop)</div>
                                <div
                                    cdkDropList
                                    class="list"
                                    (cdkDropListDropped)="reorderTasks($event, blockIndex)"
                                >
                                    @for (
                                        task of seqList;
                                        track task.id
                                    ) {
                                        <div class="box" cdkDrag>
                                            {{ getTaskName(task.id) || 'Lade...'}}
                                            <button
                                                class="badge"
                                                [ngClass]="getStateColor(task.id)"
                                            >
                                                {{ getStateText(task.id) || 'Dormant' | transloco}}
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            </div>
            <button mat-stroked-button class="full-width" (click)="addTaskBlock()">Neuen Block hinzufügen</button>

        </mat-dialog-content>
            </mat-tab>
            <mat-tab [label]="(selectedConsumerName$ | async) || 'Metadaten'">
                <mat-dialog-content class="grid">
                    <pixl-object-consumer-metadata [parentForm]="formGroup" [objectType]="isExamKind ? 'examSequence' : 'exerciseSequence'"></pixl-object-consumer-metadata>
                </mat-dialog-content>
            </mat-tab>
        </mat-tab-group>
    </form>
    <mat-divider></mat-divider>

    <mat-dialog-actions>
        <button mat-raised-button (click)="onCancel()">Abbruch</button>
        <button
            mat-raised-button
            (click)="onSave()"
            [disabled]="
                !formGroup.valid || formGroup.controls['name'].value === ''
            "
        >
            Speichern
        </button>
    </mat-dialog-actions>
</div>
